module.exports = __webpack_public_path__ + "img/laba_bersih.260d162c.svg";